import { QueryStatus } from 'types'

export const isResolved = <Q extends {queryStatus: QueryStatus}>(query: Q): boolean => {
  return [QueryStatus.WorkPack, QueryStatus.Sideletter, QueryStatus.Closed].includes(query.queryStatus)
}
